/** LocalDev packaging opts in; an ordinary production build stays recorder-free. */
export function isRecorderUiEnabled(): boolean {
  return process.env.NODE_ENV !== 'test' && (
    process.env.NODE_ENV === 'development' || process.env.REACT_APP_PIPEEX_RECORDER === '1'
  );
}
